export default __webpack_public_path__ + "static/media/le_lion15.e549b0d7.jpg";